import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  TextField,
  Button,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import axios from 'axios'
import { Link } from 'react-router-dom';

interface ContactDialogProps {
  isOpen: boolean;
  onClose: () => void;
  form: {
    name: string;
    email: string;
    phone: string;
    country: string;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  icons: {
    whatsapp: string;
    telegram: string;
    signal: string;
  };
}

const ContactDialog: React.FC<ContactDialogProps> = ({
  isOpen,
  onClose,
  form,
  onChange,
  onSubmit,
  icons,
}) => {
  const BASE_URL = 'https://app.dfopsa.online'
  const [mailFormImg, setMailFormImg] = useState<string>('')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/api/footer?populate=mailFormImg`
        )
        const explore = res?.data?.data?.countryes || []
        const mainNameImg = res?.data?.data?.mailFormImg?.url || ''
        setMailFormImg(mainNameImg);
console.log('Mail Form Image:', BASE_URL+mainNameImg)  
      } catch (error) {
        console.error('Failed to fetch statistic data:', error)
      }
    }

    fetchData()
  }, [])

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{ '.MuiPaper-root': { borderRadius: '14px' } }}
    >
      <DialogTitle>
          <Typography
            sx={{
              textAlign: 'center',
              padding: '5px',
              fontSize: '30px',
              fontWeight: 'bold'
            }}
          >
                    Let's connect now?
          </Typography>

        <Box display="flex" justifyContent="center" gap={2}>
          <IconButton
            sx={iconStyle}
            href="https://wa.me/"
            target="_blank"
          >
            <img style={iconImgStyle} src={icons.whatsapp} alt="whatsapp" />
          </IconButton>
          <IconButton
            sx={iconStyle}
            href="https://t.me/"
            target="_blank"
          >
            <img style={iconImgStyle} src={icons.telegram} alt="telegram" />
          </IconButton>
          <IconButton
            sx={iconStyle}
            href="https://signal.org/"
            target="_blank"
          >
            <img style={{ width: 38, height: 38 }} src={icons.signal} alt="signal" />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider variant="middle" sx={{ borderColor: '#4CAF50' }} />
      <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >

         <Typography
           sx={{
            textAlign: 'center',
            padding: '5px',
            fontSize: '25px',
            fontWeight: 'bold'
            }}
          > 
            Prefer to share your details and we'Il connect?
          </Typography>
          <Link to="/contactUs">
            <img
              style={{ width: 100, height: 100 }}
              src={`${BASE_URL}${mailFormImg}`}
              alt="icon"
            />
          </Link>

{/* 
        <Box
          component="form"
          onSubmit={onSubmit}
          sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <TextField
            label="Name"
            name="name"
            value={form.name}
            onChange={onChange}
            required
            fullWidth
            size="small"
          />
          <TextField
            label="Email"
            name="email"
            type="email"
            value={form.email}
            onChange={onChange}
            required
            fullWidth
            size="small"
          />
          <TextField
            label="Phone"
            name="phone"
            value={form.phone}
            onChange={onChange}
            fullWidth
            size="small"
          />
          <TextField
            label="Country"
            name="country"
            value={form.country}
            onChange={onChange}
            required
            fullWidth
            size="small"
          />
          <Button
            sx={{ height: 40, backgroundColor: '#4CAF50' }}
            type="submit"
            variant="contained"
            fullWidth
          >
            Send
          </Button>
        </Box>
         */}
        
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const iconStyle = {
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backdropFilter: 'blur(.5px)',
    zIndex: 1400,
  },
};

const iconImgStyle = { width: 40, height: 40 };

export default ContactDialog;
